
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./profanity-check.cjs.production.min.js')
} else {
  module.exports = require('./profanity-check.cjs.development.js')
}
